import type React from "react";

export function TableSortIcon({ sorted, desc }: { sorted?: boolean; desc?: boolean }): React.ReactNode {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-table-sort-icon-height w-table-sort-icon-width shrink-0"
    >
      <path
        d="M1.5 4 L4.5 1.5 L7.5 4"
        stroke={sorted && desc ? "var(--color-text-brand-secondary)" : "var(--color-text-tertiary)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth={sorted && desc ? "var(--table-sort-stroke-active)" : "var(--table-sort-stroke-default)"}
      />
      <path
        d="M1.5 8 L4.5 10.5 L7.5 8"
        stroke={sorted && !desc ? "var(--color-text-brand-secondary)" : "var(--color-text-tertiary)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth={sorted && !desc ? "var(--table-sort-stroke-active)" : "var(--table-sort-stroke-default)"}
      />
    </svg>
  );
}
